import { goalKey, unitWord } from "../../../goals/goalRules";

/**
 * Sıralamadaki ortak hedef süzgecinin saf mantığı. Hedef kimliği ad + biçimdir
 * (goalKey; biçimi olmayan eski hedef okuma sayılır), aynı ad farklı biçimse
 * ayrı seçenektir.
 */

function memberValue(member, key) {
  let found = false;
  let total = 0;
  for (const g of member?.goals || []) {
    if (goalKey(g.label, g.activity) !== key) continue;
    found = true;
    total += Number(g.value) || 0;
  }
  return found ? total : null;
}

/**
 * En az iki kardeşte bulunan hedefler, ilk görünme sırasıyla:
 * [{ key, label, activity, unit, count }]. activity boşsa "okuma".
 */
export function commonGoalOptions(members) {
  const byKey = new Map();
  for (const m of members || []) {
    const seen = new Set();
    for (const g of m?.goals || []) {
      const key = goalKey(g.label, g.activity);
      if (seen.has(key)) continue;
      seen.add(key);
      const entry = byKey.get(key);
      if (entry) {
        entry.count += 1;
        if (!entry.unit && g.unit) entry.unit = g.unit;
      } else {
        byKey.set(key, {
          key,
          label: String(g.label ?? "").trim(),
          activity: key.slice(key.lastIndexOf("::") + 2),
          unit: g.unit || null,
          count: 1,
        });
      }
    }
  }
  return [...byKey.values()].filter((o) => o.count >= 2);
}

/**
 * Seçili hedefe göre satırlar: yalnız o hedefi olan kardeşler, yapılan miktara
 * göre azalan (eşitlikte asıl sıra korunur), sıra 1..n yeniden. Her satırda
 * goalValue (yapılan), goalUnit ve barRate (en yükseğe göre yüzde) bulunur.
 */
export function filterByGoal(members, key) {
  const rows = [];
  (members || []).forEach((m, index) => {
    const value = memberValue(m, key);
    if (value === null) return;
    const own = (m.goals || []).find((g) => goalKey(g.label, g.activity) === key && g.unit);
    rows.push({ member: m, index, value, unit: own ? own.unit : null });
  });
  rows.sort((a, b) => b.value - a.value || a.index - b.index);
  const top = rows.length ? rows[0].value : 0;
  const list = rows.map((r, i) => ({
    ...r.member,
    rank: i + 1,
    goalValue: r.value,
    goalUnit: r.unit,
    barRate: top > 0 ? Math.round((r.value / top) * 100) : 0,
  }));
  const total = rows.reduce((sum, r) => sum + r.value, 0);
  return { members: list, total };
}

/** "15 sayfa"; birim yoksa yalnız sayı. Küsuratlı değer bir haneye yuvarlanır. */
export function formatAmount(value, unit, t) {
  const n = Math.round((Number(value) || 0) * 10) / 10;
  return unit ? `${n} ${unitWord(unit, t)}` : String(n);
}
